import React, { useState } from 'react';
import useAuth from '../../user/utils/auth/useAuth';
import styled, { css } from 'styled-components';
import { Anchor } from '../../common/interfaces';
import TouchableItem from '../../common/components/basic/TouchableItem';
import { MaxWidth } from '../../common/base';
import Button from '../../common/components/basic/Button';
import { useTranslation } from 'react-i18next';
import LanguagePopoverSelector from '../../common/components/form/LanguagePopoverSelector';

type MenuContainerProps = {
  isOpen?: boolean;
};

const MenuItem = styled.div`
  text-align: center;
  margin: 10px 0;
  a {
    display: block;
    color: ${({ theme: { colors } }) => colors.light.primary};
    font-size: 18px;
    font-weight: 600;
    padding: 8px 0;

    &:hover {
      color: ${({ theme: { colors } }) => colors.primary.secondary};
    }
  }
`;

const MenuContainer = styled.div<MenuContainerProps>`
  position: fixed;
  z-index: 100;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: ${({ theme: { colors } }) => colors.primary.primary};
  transform: translateY(-150%);
  transition: all ease-in-out 0.4s;
  display: flex;
  ${props =>
    props.isOpen &&
    css`
      ${MaxWidth.md`
        transform: translateY(0);
        padding: 16px;
      `}
    `}
`;

export default function HeaderMobile({ menus, authMenus, onLanguageChange = undefined }) {
  const { t } = useTranslation();
  const { isLoggedIn, logout } = useAuth();
  const [isOpen, setIsOpen] = useState();
  return (
    <div
      css={css`
        height: 80px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      `}
    >
      <div>
        <Anchor href={'/'}>
          <img
            src="https://s3-ap-southeast-1.amazonaws.com/static.rupiahtoken.com/images/logo/logo-rpt.svg"
            className="logo"
            alt="RupiahToken logo"
            width={162}
          />
        </Anchor>
      </div>
      <div
        css={css`
          display: flex;
          align-items: center;
        `}
      >
        <div style={{ paddingRight: 20 }}>
          <LanguagePopoverSelector onChange={onLanguageChange} />
        </div>
        <TouchableItem onClick={() => setIsOpen(true)}>
          <img
            src="https://s3-ap-southeast-1.amazonaws.com/static.rupiahtoken.com/images/icon/menu.svg"
            alt="Header - Menu"
          />
        </TouchableItem>
      </div>
      <MenuContainer isOpen={isOpen}>
        <div
          css={css`
            flex: 1;
            display: flex;
            flex-direction: column;
          `}
        >
          <div
            css={css`
              display: flex;
              flex-direction: column;
              flex: 1;
            `}
          >
            <div
              css={css`
                display: flex;
                justify-content: space-between;
              `}
            >
              <img
                src="https://s3-ap-southeast-1.amazonaws.com/static.rupiahtoken.com/images/logo/logo-rpt-white.svg"
                className="logo"
                alt="RupiahToken logo"
                width={162}
              />
              <div
                role="button"
                css={css`
                  cursor: pointer;
                `}
                onKeyPress={k => k.key === 'Enter' && setIsOpen(false)}
                onClick={() => setIsOpen(false)}
              >
                <img
                  src="https://s3-ap-southeast-1.amazonaws.com/static.rupiahtoken.com/images/icon/close.svg"
                  alt="Header - Close"
                />
              </div>
            </div>
            <div
              css={css`
                flex: 1;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
              `}
            >
              {menus.concat(isLoggedIn ? authMenus : []).map((menu, idx) => (
                <MenuItem key={`mobile-${idx}`} onClick={() => setIsOpen(false)}>
                  <Anchor href={menu.link}>{menu.label}</Anchor>
                </MenuItem>
              ))}
            </div>
          </div>
          <div>
            {!isLoggedIn && (
              <Anchor href="/signin">
                <Button type="primary" inverse>
                  {t('menu.login', 'Login')}
                </Button>
              </Anchor>
            )}
            {isLoggedIn && (
              <Button
                type="primary"
                inverse
                onClick={() => {
                  logout();
                  setIsOpen(false);
                }}
              >
                {t('menu.logout', 'Logout')}
              </Button>
            )}
          </div>
        </div>
      </MenuContainer>
    </div>
  );
}
